import gql from 'graphql-tag';

export default gql`
  query cartGetDeliveryDateOffs($supplierId: Int!) {
    cartGetDeliveryDateOffs(supplierId: $supplierId)
  }
`;
